import React from "react"
import Chart from "react-google-charts"
import { Row } from "react-bootstrap";
import { PieProps } from "../../../Generator/Charts/Torta";
import TortaNull from "../../../Generator/Charts/TortaDefault";

export interface rank {
    cantidad: number,
    estatus: number
}
export default class Dipositivos extends React.Component<{}, PieProps>{
    constructor(p: any) {
        super(p);
        this.state = { title: '', values: [] };
    }
    render() {
        const { title, values } = this.state;
        return <Row>
            <div style={{ textAlign: 'center' }}>
                {(values.length > 0) ? <Chart
                    width='25rem'
                    height='15rem'
                    chartType="PieChart"
                    loader={<TortaNull />}
                    data={[['DISPOSITIVOS', 'CANT'], ...values]}
                    options={{ title }}
                    rootProps={{ 'data-testid': '3' }}
                /> : <TortaNull />}
                <h5>DISPOSITIVOS</h5>
            </div>
        </Row>
    }
    componentDidMount() {
        this.send()
    }
    async send() {
        try {
            let token = localStorage.getItem('Authorization');
            let response = await fetch('/api/Web/Metricas/Dispositivos', { headers: { 'Authorization': 'Bearer ' + token } });
            let values = await response.json();
            this.setState({ values });
        } catch (error) {
            console.log(error);
            this.setState({ values: [] });
        }
    }
}